module.exports = __webpack_public_path__ + "img/iconBill.2df9f02c.png";